import { z } from 'zod';

interface ManageLuzmoReportControlNamesType {
  internal_name: 'internal_name';
  luzmo_name: 'luzmo_name';
  is_universal: 'is_universal';
  companies: 'companies';
  filters: 'filters';
  dashboard_id: 'dashboard_id';
}

export const luzmoReportSchema = z.object({
  internal_name: z.string().min(3, 'Required.'),
  luzmo_name: z.array(
    z
      .object({
        name: z.string(),
        value: z.number().or(z.string()),
      })
      .optional()
  ),
  companies: z.array(
    z
      .object({
        name: z.string(),
        value: z.number().or(z.string()),
      })
      .optional()
  ),
  is_universal: z.boolean().default(false),
  filters: z.array(z.string()),
  dashboard_id: z.string(),
});

export const ManageLuzmoReportControlNames: ManageLuzmoReportControlNamesType =
  {
    internal_name: 'internal_name',
    luzmo_name: 'luzmo_name',
    is_universal: 'is_universal',
    companies: 'companies',
    filters: 'filters',
    dashboard_id: 'dashboard_id',
  };

export type LuzmoReportSchemaType = z.infer<typeof luzmoReportSchema>;
